import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-196a7cf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "value", "name", "checked", "disabled"]
const _hoisted_2 = ["for", "data-number", "data-show-number"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      type: "radio",
      id: _ctx.id,
      value: _ctx.value,
      name: _ctx.name,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
      checked: _ctx.modelValue === _ctx.value,
      disabled: _ctx.disabled
    }), null, 16, _hoisted_1),
    _createElementVNode("label", {
      for: _ctx.id,
      "data-number": _ctx.numberLabel,
      "data-show-number": _ctx.showNumber
    }, null, 8, _hoisted_2)
  ], 64))
}